import React from 'react';
import { StoreBasicInfoComponent } from './store-basic-info.component';
import _ from 'lodash';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import StoreAddressComponent from './store-address.component';
import { StoreConfigurationInfoComponent } from './store-configuration-info.component';
import StorePickupInfoComponent from './store-pickup-info.component';
import { StoreBannerInfoComponent } from './store-banner-info.component';


function StoreComponent ({ deleteStorePickPoint, back, storeBanner, currencyCodeType, selectedStore, pickupPoints, openConfirmation, handleChannelBannerItemChange, changeImage, changeBannerImage, handleInnerbasicFormChange,handleFormSubmit, onInnerFormChange,selectedAddress }: any) {

    const tabItems=[
        {
            id:1,
            title:'Store Details',
            component:<StoreBasicInfoComponent
            currencyCodeType={currencyCodeType}
            onInnerFormChange={onInnerFormChange}
            selectedStore={selectedStore}
        />,
        isVisible:true,
        },
        {
            id:2,
            title:'Address',
            component: 
            <StoreAddressComponent
                     selectedStore={selectedStore}
                     handleInnerbasicFormChange={handleInnerbasicFormChange}
                     selectedAddress={selectedAddress}
                     onInnerFormChange={onInnerFormChange}
                     />,
            isVisible:true,
        },
        {
            id:3,
            title:'Configurations',
            component:

            <StoreConfigurationInfoComponent
                       changeImage={changeImage}
                       onInnerFormChange={onInnerFormChange}
                       selectedStore={selectedStore}
                   />,
            isVisible:true,
        },
        {
            id:4,
            title:'Store Banners',
            component:  <StoreBannerInfoComponent
            storeBanner={storeBanner}
            changeBannerImage={changeBannerImage} 
            handleChannelBannerItemChange={handleChannelBannerItemChange}
        />,
            isVisible:true,
        },
        {
            id:5,
            title:'Store Pickup points',
            component:
            <StorePickupInfoComponent
                     deleteStorePickPoint={deleteStorePickPoint}
                     onInnerFormChange={onInnerFormChange}
                     openConfirmation={openConfirmation}
                     pickupPoints={pickupPoints}
                     selectedStore={selectedStore}
                 />,
            isVisible:true,
        },
      ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
    <TabContainer tabItems={tabItems} />
 
    <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
           <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}
          
            type="submit"
        >
          Save
        </button>
      </div>
     </div>
  );
}
export default StoreComponent;
